import makeLogger from "../shared/lib/log";

const logger = makeLogger("ai.roas.shopify");

interface Shopify {
  routes: {
    root: string;
  };
}

interface Cart {
  attributes: Record<string, any>;
}

export class ShopifyCart {
  async setAttributes(attributes: Record<string, any>): Promise<void> {
    if (!("Shopify" in window)) {
      logger.warn("not a shopify store", { attributes });
      return;
    }
    try {
      const Shopify = window.Shopify as Shopify;
      const { attributes: existingAttributes }: Cart = await (
        await fetch(`${Shopify.routes.root}cart.js`)
      ).json();
      logger.debug("received attributes", { existingAttributes });
      const mergedAttributes = { ...existingAttributes, ...attributes };
      logger.debug("writing attributes", { mergedAttributes });
      await fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ attributes: mergedAttributes }),
      });
    } catch (error) {
      logger.error("failed to setAttributes", { error });
    }
  }
}
